import { useState, useEffect } from 'react';
import { CXoneClient } from '@nice-devone/agent-sdk';
export var useSkillActivityCallCount = function (isSessionActive, agentSkills) {
    var _a = useState(0), activeCallsCount = _a[0], setActiveCallsCount = _a[1];
    useEffect(function () {
        if (!isSessionActive) {
            setActiveCallsCount(0);
            return;
        }
        // Start polling for skill activity
        CXoneClient.instance.skillActivityQueue.skillActivityProvider.startPolling({});
        // Get agent's inbound skill IDs
        var agentInboundSkillIds = agentSkills
            .filter(function (skill) { return !skill.isOutbound; })
            .map(function (skill) { return skill.skillId; });
        var subscription = CXoneClient.instance.skillActivityQueue.skillActivityEvent.subscribe(function (response) {
            if (response === null || response === void 0 ? void 0 : response.skillActivityData) {
                // Filter for agent's inbound skills and sum their queueCount
                var totalCalls = response.skillActivityData
                    .filter(function (skill) {
                    return agentInboundSkillIds.includes(skill.skillId) &&
                        skill.queueCount > 0;
                })
                    .reduce(function (sum, skill) { return sum + skill.queueCount; }, 0);
                setActiveCallsCount(totalCalls);
            }
        });
        return function () {
            subscription.unsubscribe();
            CXoneClient.instance.skillActivityQueue.skillActivityProvider.terminatePolling();
        };
    }, [isSessionActive, agentSkills]);
    return activeCallsCount;
};
